import React from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

/**
 * for this page
 */
import LeftInfo from './leftInfo';
import RightPart from './rightPart';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染网页布局
     */
    render() {
        // console.log(this.props);
        const { contactInfo, contactRightPart } = this.props.content;
        /**
         * 组件分发数据
         */

        return (
            <div className={styles.content}>
                <div className={`${styles.contentWrap} clearfix`}>
                    <Chip id="30006" type="static" title="联系信息" groupName="正文" content={contactInfo}>
                        <LeftInfo content={contactInfo} />
                    </Chip>
                    <Chip id="30007" type="static" title="联系我们右侧" groupName="正文" content={contactRightPart}>
                        <RightPart content={contactRightPart} />
                    </Chip>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Content);
